import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['body', 'arrow', 'cross' ]
  static values = { open: Boolean}

  connect() {
    this.element[this.identifier] = this
    this.hiddenClass = 'hidden'
  }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.openValue) {
      this._open()
    } else {
      this._close()
    }
  }

  _open() {
    this.element.setAttribute('aria-expanded', 'true')
    this.bodyTarget.style.maxHeight = "574px";
    this.arrowTarget.classList.add(this.hiddenClass)
    this.crossTarget.classList.remove(this.hiddenClass)
  }

  _close() {
    this.element.setAttribute('aria-expanded', 'false')
    this.bodyTarget.style.maxHeight = "0px";
    this.arrowTarget.classList.remove(this.hiddenClass)
    this.crossTarget.classList.add(this.hiddenClass)
  }
}
